import React from "react";
import Select from "react-select";
import { Button } from "aible";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";
import { LineInput } from "components/Inputs/LineInput";

import RedirectContainer from "containers/Login/Redirect";

import Logo from "images/logo1.png";
import ChatAibleLogo from "images/Aible_Logo/chataible.svg";
import DellPoweredByAibleLogo from "images/Aible_Logo/dell-powered-by-aible.svg";

import styles from "./style.module.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { isEnabled } from "utils/featureFlags";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/aible/Dialog/Dialog";

export default class Login extends React.Component {
  state = {
    acceptToS: undefined
  };

  handleKeyPress(event) {
    const { handleLogin } = this.props;

    const { acceptToS } = this.state;

    if (event.key == "Enter") {
      acceptToS && handleLogin(this.refs.username.value, this.refs.password.value);
    }
  }

  componentDidMount() {
    const { email, getHasAcceptedToS, isDellDomain } = this.props;

    if (email) {
      this.refs.username.value = email;
      const hasAcceptedToS = getHasAcceptedToS(this.refs.username.value);
      this.setState({ acceptToS: isDellDomain ? true : hasAcceptedToS });
    }
  }

  render() {
    const {
      isLoading,
      isCreated,
      isLoggedOn,
      error,
      tenants,
      selectTenant,
      updateIsLoggedOn,
      handleLogout,
      handleLogin,
      history,
      getHasAcceptedToS,
      isDellDomain,
      domainRedirect,
      uiState,
      shareWithNewUser
    } = this.props;

    const { acceptToS } = this.state;

    if (domainRedirect !== undefined) {
      return <RedirectContainer />;
    }

    const hasAcceptedToS = acceptToS === undefined ? getHasAcceptedToS(this.refs.username?.value) : undefined;

    const isTosChecked = acceptToS === undefined ? hasAcceptedToS : acceptToS;

    return (
      <div className={styles.body}>
        <div className={styles.loginBox}>
          <div className={styles.loginHeader}>
            <div className={styles.name}>
              <img
                className={styles.logoImage}
                src={isDellDomain ? DellPoweredByAibleLogo : isEnabled("chat-aible-consumer") ? ChatAibleLogo : Logo}
              />
            </div>
          </div>
          {uiState?.type === "SHARE_LINK" ? (
            <div className={styles.loginContent}>
              <div className={styles.createdMessage} style={{ marginTop: "20px", fontWeight: "bold" }}>
                {`Loading ${uiState?.name ?? "Chat App"}...`}
              </div>
              <div className={styles.createdMessage} style={{ marginBottom: "20px" }}>
                <LoadingIndicator />
              </div>
            </div>
          ) : isCreated === true ? (
            <div className={styles.loginContent}>
              <div className={styles.createdMessage} style={{ marginTop: "20px", fontWeight: "bold" }}>
                {"Almost Done!"}
              </div>
              <div className={styles.createdMessage} style={{ marginBottom: "20px" }}>
                {
                  "We will validate and activate your account shortly. Once validation is complete you will receive a verification email to complete your account setup."
                }
              </div>
            </div>
          ) : isLoggedOn ? (
            <div className={styles.loginContent}>
              <div className={styles.inputHolder}>
                <div>{"Workspace Selection:"}</div>
                <Select
                  placeholder="Select a Workspace"
                  options={tenants}
                  onChange={(val) => selectTenant(val.extra)}
                />
              </div>
              <div className={styles.newUser}>
                <div>
                  {"Switch User?"}
                  <a
                    onClick={() => {
                      console.log("Switching user.");
                      handleLogout();
                      return updateIsLoggedOn(false);
                    }}
                    style={{ marginLeft: "5px" }}
                  >
                    {"Click here"}
                  </a>
                </div>
              </div>
            </div>
          ) : (
            <div className={styles.loginContent}>
              <div className={styles.inputHolder}>
                <div>{"Email:"}</div>
                <input
                  ref="username"
                  type="username"
                  className={styles.input}
                  onChange={(v) =>
                    this.setState({
                      acceptToS: getHasAcceptedToS(this.refs.username.value)
                    })
                  }
                />
              </div>
              <div className={styles.inputHolder} style={{ marginTop: "15px" }}>
                <div>{"Password:"}</div>
                <input
                  ref="password"
                  type="password"
                  className={styles.input}
                  onKeyPress={(event) => this.handleKeyPress(event)}
                  heap-ignore="true"
                />
              </div>
              <div className={styles.buttonHolder}>
                {!isDellDomain && (
                  <div className={styles.tMsg}>
                    <input
                      type="checkbox"
                      style={{ margin: "2px 10px 2px 0px", cursor: "pointer" }}
                      checked={isTosChecked}
                      onChange={() => {
                        this.setState({ acceptToS: !acceptToS });
                      }}
                    />
                    <div>
                      <span style={{ marginRight: "4px" }}>{"I have read and agree to the"}</span>
                      <a href="https://www.aible.com/aible-terms-of-use/" rel="noreferrer" target="_blank">
                        {"Terms of Use"}
                      </a>
                      <span style={{ margin: "0px 4px" }}>{"and"}</span>
                      <a
                        style={{ display: "inline-block" }}
                        href="https://www.aible.com/privacy-policy"
                        rel="noreferrer"
                        target="_blank"
                      >
                        {"privacy policy"}
                      </a>
                    </div>
                  </div>
                )}
                <Button
                  type={"primary"}
                  onClick={() => handleLogin(this.refs.username.value, this.refs.password && this.refs.password.value)}
                  disabled={(!isDellDomain && !isTosChecked) || isLoading === true}
                  className={styles.button}
                >
                  {"Login"}
                </Button>
              </div>
              {Boolean(error) && (
                <div className={styles.errorHolder + " " + styles.blockDisplay}>
                  <div className={styles.errorHeader}>
                    <div className={styles.centeredError}>
                      <div className={styles.imgHolderWarning}>
                        <FontAwesomeIcon icon={faExclamationTriangle} />
                      </div>
                      <div className={styles.errorHeaderTitle}>Error</div>
                    </div>
                  </div>
                  <div className={styles.errorMessage}>
                    <div className={styles.error}>
                      {typeof error === "string" &&
                      error !== "Failed to fetch" &&
                      error !== "There was an error in processing your request. Please try again." ? (
                        error
                      ) : (
                        <span>
                          There was an error in processing your request.
                          <br />
                          Please try again.
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              )}
              <div className={styles.newUser}>
                {uiState?.type === "SHARE" && (
                  <a onClick={() => this.setState({ showChatAppModal: true })} style={{ margin: "0px auto" }}>
                    {"Create New Account"}
                  </a>
                )}
                <a onClick={() => history.push("/reset")} style={{ margin: "0px auto" }}>
                  {"Reset Password"}
                </a>
              </div>
              {isLoading === true && <LoadingIndicator />}
            </div>
          )}
        </div>
        {isEnabled("internal-debug-display-messages-on-login", false) && (
          <div>{this.props.location?.state?.displayOnLoginScreen}</div>
        )}
        <CreateAccountForChatAppModal
          showModal={this.state.showChatAppModal}
          updateShowModal={(val) => this.setState({ showChatAppModal: val })}
          uiState={uiState}
          shareWithNewUser={shareWithNewUser}
        />
      </div>
    );
  }
}

class CreateAccountForChatAppModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      email: "",
      loading: false,
      accountRequested: false
    };
  }

  handleClose() {
    const { updateShowModal } = this.props;
    this.setState({
      accountRequested: false
    });
    updateShowModal(false);
  }

  render() {
    const { showModal, uiState, shareWithNewUser } = this.props;

    return (
      <Dialog open={showModal} onOpenChange={() => this.handleClose()}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>{`Create new account for ${uiState?.name ? uiState?.name + " " : ""}Chat App`}</DialogTitle>
          </DialogHeader>

          <div>
            <div className={styles.modalItem}>
              <div className={styles.modalLabel}>{"Email"}</div>
              <div className={styles.modalContent}>
                <LineInput
                  isBox
                  placeholder={"Enter Your Email"}
                  value={this.state.email}
                  onChange={(val) => this.setState({ email: val })}
                  inputStyle={{ width: "100%" }}
                />
              </div>
            </div>
            {this.state.accountRequested && (
              <div className={styles.modalItem}>
                {this.state.accountRequested === "TOKEN_IS_NULL"
                  ? "There was an error with the link. Please request a new link as the current one may be expired."
                  : "You've been sent an email with a confirmation link. Please check your inbox to finish creating your account."}
              </div>
            )}
          </div>
          <DialogFooter>
            <Button type="secondary" onClick={() => this.handleClose()} style={{ marginRight: "auto" }}>
              {"Close"}
            </Button>
            <Button
              type="primary"
              onClick={() => {
                this.setState({ loading: true });
                return shareWithNewUser(this.state.email).then((r) => {
                  let retVal = r && typeof r === "string" ? r : true;
                  this.setState({
                    loading: false,
                    accountRequested: retVal
                  });
                });
              }}
              isLoading={this.state.loading}
            >
              {"Create Account"}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    );
  }
}
